type ViewportRange = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

interface ImageData {
    id: number;
    src: string;
    alt: string;
    label: string;
    rotation?: number;
    shadowRotation?: number;
    closeButton?: {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
    };
    responsiveCloseButton?: Record<
        ViewportRange,
        {
            top?: string;
            bottom?: string;
            left?: string;
            right?: string;
        }
    >;
    size?: {
        width: number;
        height: number;
    };
    responsiveSize?: Record<ViewportRange, { width: number; height: number }>;
    hitboxSize?: Record<ViewportRange, { width: number; height: number }>;
    hitboxPosition?: Record<ViewportRange, { x: number; y: number }>;
}

export const foodImages: ImageData[] = [
    {
        id: 1,
        src: '/images/floating-food/holies.png',
        alt: 'Holies',
        label: 'merken',
        rotation: 0,
        shadowRotation: -12,
        responsiveCloseButton: {
            sm: { top: '105px', left: '55px' },
            md: { top: '105px', left: '55px' },
            lg: { top: '150px', left: '90px' },
            xl: { top: '150px', left: '90px' },
            '2xl': { top: '170px', left: '135px' },
        },
        responsiveSize: {
            sm: { width: 262, height: 359 },
            md: { width: 262, height: 359 },
            lg: { width: 372, height: 490 },
            xl: { width: 372, height: 490 },
            '2xl': { width: 502, height: 629 },
        },
        hitboxSize: {
            sm: { width: 109, height: 178 },
            md: { width: 109, height: 178 },
            lg: { width: 153, height: 249 },
            xl: { width: 153, height: 249 },
            '2xl': { width: 211, height: 343 },
        },
        hitboxPosition: {
            sm: { x: 75, y: 45 },
            md: { x: 75, y: 45 },
            lg: { x: 107, y: 60 },
            xl: { x: 107, y: 60 },
            '2xl': { x: 140, y: 60 },
        },
    },
    {
        id: 2,
        src: '/images/floating-food/aubergine.png',
        alt: 'Aubergine',
        label: 'organisaties',
        rotation: 20,
        shadowRotation: 26,
        responsiveCloseButton: {
            sm: { top: '110px', left: '135px' },
            md: { top: '110px', left: '135px' },
            lg: { top: '290px', left: '120px' },
            xl: { top: '290px', left: '120px' },
            '2xl': { top: '320px', left: '165px' },
        },
        responsiveSize: {
            sm: { width: 321, height: 428 },
            md: { width: 321, height: 428 },
            lg: { width: 491, height: 545 },
            xl: { width: 491, height: 545 },
            '2xl': { width: 591, height: 588 },
        },
        hitboxSize: {
            sm: { width: 98, height: 235 },
            md: { width: 98, height: 235 },
            lg: { width: 137, height: 328 },
            xl: { width: 137, height: 328 },
            '2xl': { width: 148, height: 381 },
        },
        hitboxPosition: {
            sm: { x: 105, y: 45 },
            md: { x: 105, y: 45 },
            lg: { x: 170, y: 40 },
            xl: { x: 170, y: 40 },
            '2xl': { x: 215, y: 30 },
        },
    },
    {
        id: 3,
        src: '/images/floating-food/msc.png',
        alt: 'MSC',
        label: 'NGO’s',
        rotation: -19,
        shadowRotation: 25,
        responsiveCloseButton: {
            sm: { bottom: '100px', left: '112px' },
            md: { bottom: '100px', left: '112px' },
            lg: { bottom: '105px', left: '60px' },
            xl: { bottom: '105px', left: '60px' },
            '2xl': { bottom: '145px', left: '165px' },
        },
        responsiveSize: {
            sm: { width: 314, height: 163 },
            md: { width: 314, height: 163 },
            lg: { width: 264, height: 253 },
            xl: { width: 264, height: 253 },
            '2xl': { width: 514, height: 353 },
        },
        hitboxSize: {
            sm: { width: 118, height: 68 },
            md: { width: 118, height: 68 },
            lg: { width: 165, height: 94 },
            xl: { width: 165, height: 94 },
            '2xl': { width: 234, height: 137 },
        },
        hitboxPosition: {
            sm: { x: 95, y: 25 },
            md: { x: 95, y: 25 },
            lg: { x: 45, y: 45 },
            xl: { x: 45, y: 45 },
            '2xl': { x: 140, y: 57 },
        },
    },
    {
        id: 4,
        src: '/images/floating-food/soep.png',
        alt: 'Soep',
        label: 'eigen initiatief',
        rotation: 47,
        shadowRotation: -15,
        responsiveCloseButton: {
            sm: { bottom: '180px', left: '122px' },
            md: { bottom: '180px', left: '122px' },
            lg: { bottom: '280px', left: '155px' },
            xl: { bottom: '280px', left: '155px' },
            '2xl': { bottom: '355px', left: '190px' },
        },
        responsiveSize: {
            sm: { width: 352, height: 321 },
            md: { width: 352, height: 321 },
            lg: { width: 422, height: 621 },
            xl: { width: 422, height: 621 },
            '2xl': { width: 522, height: 771 },
        },
        hitboxSize: {
            sm: { width: 90, height: 130 },
            md: { width: 90, height: 130 },
            lg: { width: 125, height: 183 },
            xl: { width: 125, height: 183 },
            '2xl': { width: 168, height: 247 },
        },
        hitboxPosition: {
            sm: { x: 130, y: 50 },
            md: { x: 130, y: 50 },
            lg: { x: 145, y: 150 },
            xl: { x: 145, y: 150 },
            '2xl': { x: 175, y: 180 },
        },
    },
];

export const IMAGE_ANCHORS: Record<number, Corner> = {
    1: 'top-right',
    2: 'top-left',
    3: 'bottom-left',
    4: 'bottom-right',
};

type Corner = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

const TEXT_MAX_W_TW: Record<ViewportRange, number> = {
    sm: 100,
    md: 137.5,
    lg: 185,
    xl: 250,
    '2xl': 325,
};

const TW_UNIT_PX = 4;

const TEXT_HEIGHT_PX: Record<ViewportRange, number> = {
    sm: 320,
    md: 260,
    lg: 260,
    xl: 250,
    '2xl': 200,
};

const ANCHOR_Y_RATIO: Record<ViewportRange, number> = {
    sm: 0.35,
    md: 0.45,
    lg: 0.45,
    xl: 0.4,
    '2xl': 0.4,
};

const CORNER_TWEAKS: Record<
    ViewportRange,
    Record<Corner, { x: number; y: number }>
> = {
    sm: {
        'top-left': { x: 0, y: 40 },
        'top-right': { x: -170, y: 190 },
        'bottom-left': { x: -100, y: 20 },
        'bottom-right': { x: -200, y: 50 },
    },
    md: {
        'top-left': { x: 0, y: 40 },
        'top-right': { x: 0, y: 50 },
        'bottom-left': { x: 0, y: 20 },
        'bottom-right': { x: -130, y: 70 },
    },
    lg: {
        'top-left': { x: 100, y: 170 },
        'top-right': { x: -140, y: 90 },
        'bottom-left': { x: 330, y: -10 },
        'bottom-right': { x: -250, y: -20 },
    },
    xl: {
        'top-left': { x: 100, y: 170 },
        'top-right': { x: -140, y: 90 },
        'bottom-left': { x: 330, y: -10 },
        'bottom-right': { x: -250, y: -20 },
    },
    '2xl': {
        'top-left': { x: 40, y: 460 },
        'top-right': { x: -110, y: 300 },
        'bottom-left': { x: 600, y: 120 },
        'bottom-right': { x: -485, y: 90 },
    },
};

export function getSpawnImageCenterFromViewportCenter({
    corner,
    viewportWidth,
    viewportHeight,
    viewport,
    hitboxSize,
    gap = 16,
}: {
    corner: Corner;
    viewportWidth: number;
    viewportHeight: number;
    viewport: ViewportRange;
    hitboxSize: { width: number; height: number };
    gap?: number;
}) {
    const textWidthPx = TEXT_MAX_W_TW[viewport] * TW_UNIT_PX;
    const textHeightPx = TEXT_HEIGHT_PX[viewport];

    const anchor = {
        x: viewportWidth / 2,
        y: viewportHeight * ANCHOR_Y_RATIO[viewport],
    };

    const signX = corner.includes('right') ? +1 : -1;
    const signY = corner.includes('bottom') ? +1 : -1;

    const dx = textWidthPx / 2 + hitboxSize.width / 2 + gap;
    const dy = textHeightPx / 2 + hitboxSize.height / 2 + gap;

    const tweak = CORNER_TWEAKS[viewport][corner];

    return {
        x: anchor.x + signX * dx + tweak.x,
        y: anchor.y + signY * dy + tweak.y,
    };
}

export const standingFoodImages: ImageData[] = [
    {
        id: 1,
        src: '/images/standing-food/holies.png',
        alt: 'Holies',
        label: 'merken',
        responsiveSize: {
            sm: { width: 257, height: 384 },
            md: { width: 257, height: 384 },
            lg: { width: 257, height: 384 },
            xl: { width: 257, height: 384 },
            '2xl': { width: 257, height: 384 },
        },
    },
    {
        id: 2,
        src: '/images/standing-food/aubergine.png',
        alt: 'Aubergine',
        label: 'organisaties',
        responsiveSize: {
            sm: { width: 369, height: 192 },
            md: { width: 369, height: 192 },
            lg: { width: 369, height: 192 },
            xl: { width: 369, height: 192 },
            '2xl': { width: 369, height: 192 },
        },
    },
    {
        id: 3,
        src: '/images/standing-food/msc.png',
        alt: 'MSC',
        label: 'NGO’s',
        responsiveSize: {
            sm: { width: 256, height: 130 },
            md: { width: 256, height: 130 },
            lg: { width: 256, height: 130 },
            xl: { width: 256, height: 130 },
            '2xl': { width: 256, height: 130 },
        },
    },
    {
        id: 4,
        src: '/images/standing-food/vrijheidsoep.png',
        alt: 'Vrijheidsoep',
        label: 'eigen initiatief',
        responsiveSize: {
            sm: { width: 222, height: 271 },
            md: { width: 222, height: 271 },
            lg: { width: 222, height: 271 },
            xl: { width: 222, height: 271 },
            '2xl': { width: 222, height: 271 },
        },
    },
    {
        id: 5,
        src: '/images/standing-food/bionext.png',
        alt: 'Bionext',
        label: 'organisaties',
        responsiveSize: {
            sm: { width: 183, height: 127 },
            md: { width: 183, height: 127 },
            lg: { width: 183, height: 127 },
            xl: { width: 183, height: 127 },
            '2xl': { width: 183, height: 127 },
        },
    },
    {
        id: 6,
        src: '/images/standing-food/brandt-levie.png',
        alt: 'Brandt & Levie',
        label: 'merken',
        responsiveSize: {
            sm: { width: 150, height: 232 },
            md: { width: 150, height: 232 },
            lg: { width: 150, height: 232 },
            xl: { width: 150, height: 232 },
            '2xl': { width: 180, height: 232 },
        },
    },
    {
        id: 7,
        src: '/images/standing-food/brood.png',
        alt: 'Brood',
        label: 'merken',
        responsiveSize: {
            sm: { width: 445, height: 361 },
            md: { width: 445, height: 361 },
            lg: { width: 445, height: 361 },
            xl: { width: 445, height: 361 },
            '2xl': { width: 445, height: 361 },
        },
    },
    {
        id: 8,
        src: '/images/standing-food/fish-tales.png',
        alt: 'Fish Tales',
        label: 'merken',
        responsiveSize: {
            sm: { width: 143, height: 88 },
            md: { width: 143, height: 88 },
            lg: { width: 143, height: 88 },
            xl: { width: 143, height: 88 },
            '2xl': { width: 143, height: 88 },
        },
    },
    {
        id: 9,
        src: '/images/standing-food/lidl.png',
        alt: 'Lidl',
        label: 'merken',
        responsiveSize: {
            sm: { width: 170, height: 177 },
            md: { width: 170, height: 177 },
            lg: { width: 170, height: 177 },
            xl: { width: 170, height: 177 },
            '2xl': { width: 170, height: 177 },
        },
    },
    {
        id: 10,
        src: '/images/standing-food/lowlander.png',
        alt: 'Lowlander',
        label: 'merken',
        responsiveSize: {
            sm: { width: 152, height: 460 },
            md: { width: 152, height: 460 },
            lg: { width: 152, height: 460 },
            xl: { width: 152, height: 460 },
            '2xl': { width: 152, height: 460 },
        },
    },
    {
        id: 11,
        src: '/images/standing-food/tromp-en-rueb.png',
        alt: 'Tromp en Rueb',
        label: 'merken',
        responsiveSize: {
            sm: { width: 148, height: 504 },
            md: { width: 148, height: 504 },
            lg: { width: 148, height: 504 },
            xl: { width: 148, height: 504 },
            '2xl': { width: 148, height: 504 },
        },
    },
    {
        id: 12,
        src: '/images/standing-food/aardappel.png',
        alt: 'Aardappel',
        label: 'merken',
        responsiveSize: {
            sm: { width: 153, height: 127 },
            md: { width: 153, height: 127 },
            lg: { width: 153, height: 127 },
            xl: { width: 153, height: 127 },
            '2xl': { width: 153, height: 127 },
        },
    },
];
